import { render, staticRenderFns } from "./quinta-do-vesuvio.vue?vue&type=template&id=bca13f5e&scoped=true"
import script from "./quinta-do-vesuvio.vue?vue&type=script&lang=js"
export * from "./quinta-do-vesuvio.vue?vue&type=script&lang=js"
import style0 from "./quinta-do-vesuvio.vue?vue&type=style&index=0&id=bca13f5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca13f5e",
  null
  
)

export default component.exports